module.exports = __webpack_public_path__ + "img/Shota Arveladze.945f3054.png";